import React from "react";

const contactData = {
  address: "Madhya Marg, sco-12 Sector 7-C, Chandigarh, 160019",
  phone: "+91 172 478 0108",
  email: "support@altrange.com",
  hours: "9:00 AM to 5:30 PM, Monday to Saturday",
  social: {
    facebook: "https://www.facebook.com/altrangeapp/",
    twitter: "https://x.com/altrangedotcom",
    youtube: "https://www.youtube.com/@Altrange_official",
    instagram:"https://www.instagram.com/altrange_official/",
    linkedin:"https://www.linkedin.com/in/altrange-altrange-51ab41352/",
  },
};

export const Contact = () => {
  return (
    <div id="contact" className="bg-light text-black py-5 border-top">
      <div className="container">
        <div className="section-title">
          <h2 className="text-center mb-4">Contact Us</h2>
        </div>


        {/* Contact Info */}
        <div className="row g-4 text-center">
          <div className="col-md-12">
         
            <p>
              <i className="fa-solid fa-location-dot me-2"></i>
              {contactData.address}
            </p>
            <p>
              <i className="fa-solid fa-phone me-2"></i>
              <a href={`tel:${contactData.phone}`} className="text-black text-decoration-none">
                {contactData.phone}
              </a>
            </p>
            <p>
              <i className="fa-solid fa-envelope me-2"></i>
              <a href={`mailto:${contactData.email}`} className="text-black text-decoration-none">
                {contactData.email}
              </a>
            </p>
            <p>
              <i className="fa-solid fa-clock me-2"></i>
              {contactData.hours}
            </p>
          </div>
        </div>

        {/* Social Media Links */}
        <div className="row mt-4 text-center">
          <div className="col-md-12">
            <div className="section-title">
              <h2 className="mb-3">Follow Us On</h2>
            </div>

            <ul className="list-inline">
              <li className="list-inline-item mx-2">
                <a href={contactData.social.facebook} target="_blank" rel="noopener noreferrer" className="btn btn-outline-dark mb-2">
                  <i className="fab fa-facebook-f me-2"></i> Facebook
                </a>
              </li>
              <li className="list-inline-item mx-2">
                <a href={contactData.social.twitter} target="_blank" rel="noopener noreferrer" className="btn btn-outline-dark mb-2">
                  <i className="fab fa-x-twitter me-2"></i> X (Twitter)
                </a>
              </li>
              <li className="list-inline-item mx-2">
                <a href={contactData.social.youtube} target="_blank" rel="noopener noreferrer" className="btn btn-outline-dark mb-2">
                  <i className="fab fa-youtube me-2"></i> Youtube
                </a>
              </li>
              <li className="list-inline-item mx-2">
                <a href={contactData.social.instagram} target="_blank" rel="noopener noreferrer" className="btn btn-outline-dark mb-2">
                  <i className="fab fa-instagram me-2"></i> Instagram
                </a>
              </li>
              <li className="list-inline-item mx-2">
                <a href={contactData.social.linkedin} target="_blank" rel="noopener noreferrer" className="btn btn-outline-dark mb-2">
                  <i className="fab fa-linkedin me-2"></i>  Linkedin
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Footer */}
        <div id="footer" className="bg-light text-black py-3 mt-5 border-top">
          <div className="container text-center">
            <p>
              &copy; {new Date().getFullYear()} Altrange Pvt Ltd. All rights reserved.
              <a href="/term&condition" className="text-black mx-2">Terms of Use</a> |
              <a href="/privacy-policy" className="text-black mx-2">Privacy Policy</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
